import {
  EMAIL_CREATION_FORM_ACCOUNT_API_PARAMS,
  EMAIL_CREATION_FORM_ACCOUNT_MASS_API_PARAMS,
  EMAIL_CREATION_FORM_ACCOUNT_SERVICE_API_PARAMS,
} from '../EmailCreationForm.constants'

export function getFromFieldAccountApiParams({ mass, withServiceAccount }) {
  if (mass) {
    return EMAIL_CREATION_FORM_ACCOUNT_MASS_API_PARAMS
  }

  if (withServiceAccount) {
    return EMAIL_CREATION_FORM_ACCOUNT_SERVICE_API_PARAMS
  }

  return EMAIL_CREATION_FORM_ACCOUNT_API_PARAMS
}
